import React from 'react';
import '../../styles/footer.css';

const Footer = () => {
  return (
    <footer id="footer" className="footer dark-background">

      <div className="container footer-top">
        <div className="row gy-4">
          <div className="col-lg-4 col-md-6 footer-about">
            <a href="/" className="logo d-flex align-items-center">
              <div className="logo-badge">
                <img src="/img/logo2.jpeg" alt="April Groups Logo" className="img-fluid logo-img" />
                <span className="logo-tagline">PART OF APRIL GROUPS</span>
              </div>
            </a>
            <div className="footer-contact pt-3">
              <p>APRIL FIRE EQUIPMENT EQUIPMENT & INSTALLATION L.L.C</p>
              <p>Deira , Hor Al Anz</p>
              <p>DUBAI, U.A.E.</p>
              <p className="mt-3"><strong>Phone :</strong> <span className="ms-1">+97 1562 702486, +97 1565 508883</span><br />
              </p>
              <p><strong>Email:</strong> <span>sales@aprilgroups.com</span></p>
            </div>
            <div className="social-links d-flex mt-4">
              <a href="#"><i className="bi bi-twitter-x"></i></a>
              <a href="#"><i className="bi bi-facebook"></i></a>
              <a href="#"><i className="bi bi-instagram"></i></a>
              <a href="#"><i className="bi bi-linkedin"></i></a>
            </div>
          </div>

          <div className="col-lg-2 col-md-3 footer-links">
            <h4>Useful Links</h4>
            <ul>
              <li><i className="bi bi-chevron-right"></i> <a href="#">Home</a></li>
              <li><i className="bi bi-chevron-right"></i> <a href="#">About us</a></li>
              <li><i className="bi bi-chevron-right"></i> <a href="#">Services</a></li>
              <li><i className="bi bi-chevron-right"></i> <a href="#">Terms of service</a></li>
              <li><i className="bi bi-chevron-right"></i> <a href="#">Privacy policy</a></li>
            </ul>
          </div>

          <div className="col-lg-2 col-md-3 footer-links">
            <h4>Our Services</h4>
            <ul>
              <li><i className="bi bi-chevron-right"></i> <a href="#">Product</a></li>
              <li><i className="bi bi-chevron-right"></i> <a href="#">Project</a></li>
              <li><i className="bi bi-chevron-right"></i> <a href="#">Maintenance</a></li>
            </ul>
          </div>

          <div className="col-lg-4 col-md-12 footer-newsletter">
            <h4>Our Newsletter</h4>
            <p>Subscribe to our newsletter and receive the latest news about our products and services!</p>
            <form action="forms/newsletter.php" method="post" className="php-email-form">
              <div className="newsletter-form"><input type="email" name="email" /><input type="submit" value="Subscribe" disabled={true} /></div>
              <div className="loading">Loading</div>
              <div className="error-message"></div>
              <div className="sent-message">Your subscription request has been sent. Thank you!</div>
            </form>
          </div>

        </div>
      </div>

      <div className="container copyright text-center mt-4">
        <p>© <span>Copyright</span> <strong className="px-1 sitename">AprilGroups</strong> <span>All Rights Reserved</span></p>
        <div className="credits">
          {/* Licensing and credits can go here */}
        </div>
      </div>

    </footer>
  );
};

export default Footer;